import React, { useState, useEffect, useCallback } from "react";
import { ACTIVE_API_BASE_URL } from "../config/apiConfig";
import apiClient from "../api/axiosClient";
import { ChevronLeft, ChevronRight, Save } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/FormProduction.css";
import SidebarGuideline from "./SidebarGuideline";
import {downloadFile} from '../common'

// Constants for max lengths
const FIELD_MAX_LENGTH = 100;
const TEXTAREA_MAX_LENGTH = 300;
const WE_FIELD_MAX_LENGTH = 200;
const PHONE_MAX_LENGTH = 10;

// Validation regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d{10}$/;

const RegistrationWE = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeItem, setActiveItem] = useState(null);
  const awardTitle =
    location.state?.awardTitle || "Woman Executive of the Year";
  const [userInfo, setUserInfo] = useState();
  const [formId, setFormId] = useState("Unknown");
  const [PkId, setPkId] = useState(0);
  const [disableSave, setDisableSave] = useState(false);

  const selectedAwardCategory = location.state?.awardTitle;

  // Form state initialization
  const [formData, setFormData] = useState({
    Organisationname: "",
    category: "Woman Executive of the Year",
    mailingAddress: "",
    authorityName: "",
    authorityTitle: "",
    authorityPhone: "",
    authorityLandline: "",
    authorityEmail: "",
    applicant_name: "",
    applicant_phone: "",
    applicant_email: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    contactapplicant: "",
    Applicantjoining: "",
    Applicantdetails: "",
    Applicantprofile: "",
    Applicantdesignation: "",
    we_applicant_name: "",
    ApplicantDOB: "",
    companyProfile: "",
    approvingAuthoritySignature: null,
    declaration: false,
    comment: "",
    WE_1: "",
    WE_2: "",
    WE_3: "",
    WE_4: "",
    WE_5: "",
    WE_6: "",
    attachments1: { description: "", file: null },
    attachments2: { description: "", file: null },
    attachments3: { description: "", file: null },
    attachments4: { description: "", file: null },
  });

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("user_info");
      if (stored) {
        const user = JSON.parse(stored);
        setUserInfo(JSON.parse(stored));
        setFormId(`womenRegistration_${user.id}`);

        setFormData((prev) => ({
          ...prev,
          userid: user.id || "",
          firstname: user.first_name || "",
          lastname: user.last_name || "",
          company_name: user.organisation_name || "",
          Organisationname: user.organisation_name || "",
          applicant_name: user.applicant_name || "",
          applicant_phone: user.applicant_phone || "",
          applicant_email: user.email || "",
        }));
      }
    } catch (err) {
      console.warn("Failed to parse user_info from localStorage:", err);
    }
  }, []);

  // This use Effect Prefill user Data using api;
  useEffect(() => {
    console.log("called we prefill useEffect");
    if (userInfo) {
      prefillFormData();
    } else {
      console.warn(
        `userInfo OR formId is invalid; Kindly check the method. and data`
      );
    }
  }, [userInfo, formId]);

  const isSubmited = () => formData?.form_mode === "submit" || disableSave;

  useEffect(() => {}, []);

  function prefillFormData() {
    const url = `/registration-we/?form_id=${formId}`;
    console.log("prefill url:", url);
    apiClient
      .get(url)
      .then((res) => {
        if (!Array.isArray(res.data) || res.data.length !== 1) {
          console.warn("prefill: response not a single item, skipping");
          return;
        }

        const item = res.data[0];
        // server primary key
        setPkId(item.id ?? item.pk ?? 0);

        // try to pull user info from returned item if available
        const serverUser =
          item.user ??
          item.user_info ??
          item.user_id ??
          (item.created_by ? { id: item.created_by } : null);

        const newFields = {
          // Identity / Org Info
          Organisationname:
            item.organisation_name ??
            item.organisationName ??
            item.company_name ??
            item.companyName ??
            "",
          category: item.category ?? "",
          mailingAddress: item.mailing_address ?? item.mailingAddress ?? "",

          // authority
          authorityName:
            item.authority_name ?? item.authorityName ?? item.authority ?? "",
          authorityTitle:
            item.authority_title ??
            item.authorityTitle ??
            item.authority_designation ??
            "",
          authorityPhone:
            item.authority_phone ??
            item.authorityPhone ??
            item.authorityTelephone ??
            "",
          authorityLandline:
            item.authority_landline ?? item.authorityLandline ?? "",
          authorityEmail: item.authority_email ?? item.authorityEmail ?? "",

          // contact / applicant (keeps both names used in different places)
          contact_name:
            item.contact_name ?? item.contactName ?? item.applicant_name ?? "",
          contact_phone:
            item.contact_phone ??
            item.contactPhone ??
            item.applicant_phone ??
            "",
          contact_email:
            item.contact_email ??
            item.contactEmail ??
            item.applicant_email ??
            "",

          // Applicant specific fields used in handleSubmit
          contactapplicant:
            item.contact_applicant ?? item.contactapplicant ?? "",
            we_applicant_name:
            item.we_applicant_name ?? item.we_applicant_name ?? "",
          ApplicantDOB:
            item.applicant_dob ?? item.applicantDOB ?? item.dob ?? "",
          Applicantdesignation:
            item.applicant_designation ??
            item.applicantDesignation ??
            item.designation ??
            "",
          Applicantprofile:
            item.applicant_profile ??
            item.applicantProfile ??
            item.profile ??
            "",
          Applicantdetails:
            item.applicant_details ??
            item.applicantDetails ??
            item.details ??
            "",
          Applicantjoining:
            item.applicant_joining ??
            item.applicantJoining ??
            item.joining_date ??
            "",

          // Other Info
          companyProfile: item.company_profile ?? item.companyProfile ?? "",
          awardJustification:
            item.award_justification ??
            item.awardJustification ??
            item.award_justification_text ??
            "",
          comment: item.comment ?? "",
          declaration: item.declaration === true || item.declaration === "true",

          // WE Questions
          WE_1: item.we_1 ?? item.we1 ?? item.WE_1 ?? "",
          WE_2: item.we_2 ?? item.we2 ?? item.WE_2 ?? "",
          WE_3: item.we_3 ?? item.we3 ?? item.WE_3 ?? "",
          WE_4: item.we_4 ?? item.we4 ?? item.WE_4 ?? "",
          WE_5: item.we_5 ?? item.we5 ?? item.WE_5 ?? "",
          WE_6: item.we_6 ?? item.we6 ?? item.WE_6 ?? "",

          // form mode / meta
          form_mode: item.form_mode ?? item.formMode ?? "draft",
        };

        // Attachments 1..4 (server commonly returns either attachments1 or attachments1_url)
        [1, 2, 3, 4].forEach((n) => {
          const descKey = `attachments${n}_desc`;
          const fileKey = `attachments${n}`;
          const urlKey = `${fileKey}_url`;

          newFields[fileKey] = {
            description: item[descKey] ?? item[`${fileKey}Desc`] ?? "",
            file: null, // file object stays null until user selects a new File
            url:
              item[fileKey] ?? item[urlKey] ?? item[`${fileKey}_path`] ?? null,
          };
        });

        // Approving authority signature: file (null) + url preview
        newFields.approvingAuthoritySignature = null;
        newFields.approvingAuthoritySignatureUrl =
          item.approving_authority_file ??
          item.approving_authority_file_url ??
          item.approvingAuthorityFileUrl ??
          item.approving_authority_file_path ??
          null;

        // User info fields that handleSubmit merges synchronously from localStorage
        newFields.userid =
          item.userid ??
          item.user_id ??
          (serverUser && serverUser.id) ??
          item.created_by ??
          "";
        newFields.firstname =
          item.firstname ??
          item.first_name ??
          (serverUser && serverUser.first_name) ??
          "";
        newFields.lastname =
          item.lastname ??
          item.last_name ??
          (serverUser && serverUser.last_name) ??
          "";
        // company_name fallback (keeps same as Organisationname if server uses company_name)
        newFields.company_name =
          item.company_name ??
          item.companyName ??
          newFields.Organisationname ??
          "";

        // If server returned any other helpful meta, keep them on the form state
        if (item.form_id) newFields.form_id = item.form_id;
        if (item.id) newFields.id = item.id;

        // Finally merge immutably with previous state so controlled inputs update
        setFormData((prev) => ({ ...prev, ...newFields }));
      })
      .catch((err) => {
        console.error("prefillFormData error:", err);
      });
  }

  // UI State
  const [currentStep, setCurrentStep] = useState(1);
  const [copyApplicantData, setCopyApplicantData] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  // Validation helpers
  const validateEmail = (email) => emailRegex.test(email);
  const validatePhone = (phone) => phoneRegex.test(phone);

  // Clear error on field
  const clearFieldError = useCallback((field) => {
    setFieldErrors((prev) => {
      if (prev[field]) {
        const { [field]: omitted, ...rest } = prev;
        return rest;
      }
      return prev;
    });
  }, []);

  // Handle changes for inputs/textareas/selects
  const handleChange = (name, value) => {
    if ([1, 2, 3, 4].includes(currentStep)) {
      let applicableMaxLength = FIELD_MAX_LENGTH;
      if (["companyProfile"].includes(name)) {
        applicableMaxLength = TEXTAREA_MAX_LENGTH;
      } else if (
        [
          "WE_1",
          "WE_2",
          "WE_3",
          "WE_4",
          "WE_5",
          "WE_6",
          "comment",
          "Applicantprofile",
          "Applicantdetails",
        ].includes(name)
      ) {
        applicableMaxLength = WE_FIELD_MAX_LENGTH;
      } else if (["Applicantprofile", "Applicantdetails"].includes(name)) {
        applicableMaxLength = 100;
      }

      if (typeof value === "string") {
        if (name === "companyProfile") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 300) {
            alert("Maximum 300 words allowed ");
            return;
          }
        } else if (name === "comment") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed in Comments.");
            return;
          }
        } else if (name === "Applicantdetails") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words are allowed ");
            return;
          }
        } else if (name === "Applicantprofile") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 100) {
            alert("Maximum 100 words are allowed ");
            return;
          }
        } else if (name === "WE_1") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words are allowed");
            return;
          }
        } else if (name === "WE_2") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words are allowed ");
            return;
          }
        } else if (name === "WE_3") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words are allowed ");
            return;
          }
        } else if (name === "WE_4") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words allowed ");
            return;
          }
        } else if (name === "WE_5") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words are allowed ");
            return;
          }
        } else if (name === "WE_6") {
          const wordCount = value.trim().split(/\s+/).length;
          if (wordCount > 200) {
            alert("Maximum 200 words are allowed");
            return;
          }
        } else if (value.length > applicableMaxLength) {
          alert(`Value cannot exceed ${applicableMaxLength} characters.`);
          return;
        }
      }
    }

    // Name validation
    if (
      [
        "Organisationname",
        "companyName",
        "authorityName",
        "contact_name",
      ].includes(name)
    ) {
      const isValid = /^[A-Za-z\s]*$/.test(value);
      if (!isValid && value !== "") {
        alert("Only letters and spaces are allowed.");
        return;
      }
    }

    // Phone validation
    if (
      ["authorityPhone", "contact_phone", "contactapplicant"].includes(name)
    ) {
      const numericValue = value.replace(/\D/g, "").slice(0, PHONE_MAX_LENGTH);
      if (numericValue.length > PHONE_MAX_LENGTH) {
        alert("Phone number must not exceed 10 digits.");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));
      clearFieldError(name);
      return;
    }

    // Default handling
    setFormData((prev) => ({
      ...prev,
      [name]: typeof value === "boolean" ? value : value || "",
    }));
    clearFieldError(name);

    if (name === "Organisationname" && value && currentStep === 1) setError("");
    if (name === "mailingAddress" && value?.trim() && currentStep === 1)
      setError("");
    if (name === "authorityName" && value && currentStep === 2) setError("");
    if (name === "authorityTitle" && value && currentStep === 2) setError("");
    if (name === "authorityEmail" && value && currentStep === 2) setError("");
    if (name === "authorityPhone" && value && currentStep === 2) setError("");
    if (name === "contactapplicant" && value && currentStep === 2) setError("");
    if (name === "ApplicantDOB" && value && currentStep === 2) setError("");
    if (name === "Applicantdesignation" && value && currentStep === 2)
      setError("");
    if (name === "Applicantjoining" && value && currentStep === 2) setError("");
    if (name === "Applicantprofile" && value && currentStep === 2) setError("");
    if (name === "Applicantdetails" && value && currentStep === 2) setError("");
  };

  // Handle checkbox for copying applicant data

  const handleCopyApplicantToggle = (e) => {
    const checked = e.target.checked;
    // setCopyApplicantData(checked);

    const model = {
      contact_name: "",
      contact_phone: "",
      contact_email: "",
    };

    if (checked) {
      const userInfo = JSON.parse(sessionStorage.getItem("user_info"));
      if (userInfo) {
        model.contact_name = userInfo.applicant_name;
        model.contact_phone = userInfo.applicant_phone;
        model.contact_email = userInfo.email;
      }
    }

    setFormData((prev) => ({ ...prev, ...model }));

    clearFieldError("contact_name");
    clearFieldError("contact_phone");
    clearFieldError("contact_email");
  };

  // Handle attachment changes
  const handleAttachmentChange = (key, field, value, event = null) => {
    if (field === "file" && value) {
      const file = value;
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for attachments.");
        if (event) event.target.value = null;
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for attachments.");
        if (event) event.target.value = null;
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
      },
    }));
    clearFieldError(key);
  };

  // Handle approving authority signature upload
  const handleApprovingAuthorityChange = (files) => {
    const file = files[0];
    if (file) {
      const maxSizeInBytes = 5 * 1024 * 1024;
      const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, PNG, and PDF files are allowed for the signature.");
        return;
      }
      if (file.size > maxSizeInBytes) {
        alert("File size must not exceed 5 MB for the signature.");
        return;
      }
      setFormData((prev) => ({
        ...prev,
        approvingAuthoritySignature: file,
      }));
      clearFieldError("approvingAuthoritySignature");
    }
  };

  function escapeHtml(str = "") {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  const handlePrint = () => {
    const title = escapeHtml(awardTitle || "");

    const bodyHtml = `
    <div style="font-family: Arial, sans-serif; padding: 20px;">
      <h1 style="text-align: center; color: #1e40af;">${title}</h1>

      <h2>Organization & Contact Details:</h2>
      <p><strong>Organisation Name:</strong> ${escapeHtml(
        formData.Organisationname || ""
      )}</p>
      <p><strong>Postal Address:</strong> ${escapeHtml(
        formData.mailingAddress || ""
      )}</p>
      <p><strong>Approving Authority Name:</strong> ${escapeHtml(
        formData.authorityName || ""
      )}</p>
      <p><strong>Approving Authority Designation:</strong> ${escapeHtml(
        formData.authorityTitle || ""
      )}</p>
      <p><strong>Approving Authority Landline:</strong> ${escapeHtml(
        formData.authorityLandline || ""
      )}</p>
      <p><strong>Approving Authority Phone:</strong> ${escapeHtml(
        formData.authorityPhone || ""
      )}</p>
      <p><strong>Approving Authority Email:</strong> ${escapeHtml(
        formData.authorityEmail || ""
      )}</p>

      <h2>Nodal Official Contact Details:</h2>
      <p><strong>Contact Name:</strong> ${escapeHtml(
        formData.contact_name || ""
      )}</p>
      <p><strong>Contact Phone:</strong> ${escapeHtml(
        formData.contact_phone || ""
      )}</p>
      <p><strong>Contact Email:</strong> ${escapeHtml(
        formData.contact_email || ""
      )}</p>


      <h2>Applicant Details:</h2>
      <p><strong>Date of Birth:</strong> ${escapeHtml(
        formData.ApplicantDOB || ""
      )}</p>
      <p><strong>Designation:</strong> ${escapeHtml(
        formData.Applicantdesignation || ""
      )}</p>
      <p><strong>Career Profile:</strong> ${escapeHtml(
        formData.Applicantprofile || ""
      )}</p>
      <p><strong>Educational Qualifications:</strong> ${escapeHtml(
        formData.Applicantdetails || ""
      )}</p>
      <p><strong>Date of Joining:</strong> ${escapeHtml(
        formData.Applicantjoining || ""
      )}</p>
      <br/>
    
      <p><strong>Mention the rationale behind applying for this award (emphasis be on quantitative achievement such as cost saving, sale enhancement, efficiency in energy consumption, safety, environment etc.):</strong> ${escapeHtml(
        formData.companyProfile || ""
      )}</p>

      <h2>Quantitative Information</h2>
      <table style="width:100%; border-collapse:collapse; margin-top:16px;">
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:8px; text-align:center;">S.No</th>
            <th style="border:1px solid #000; padding:8px; text-align:left;">Particulars</th>
            <th style="border:1px solid #000; padding:8px; text-align:center;">Details</th>
          </tr>
        </thead>
        <tbody>
          ${
            Array.isArray(fullData)
              ? fullData
                  .map(
                    ([num, label, key]) => `
                <tr>
                  <td style="border:1px solid #000; padding:8px; text-align:center; vertical-align:middle;">${escapeHtml(
                    num
                  )}</td>
                  <td style="border:1px solid #000; padding:8px; text-align:start; vertical-align:middle;">${escapeHtml(
                    label
                  )}</td>
                  <td style="border:1px solid #000; padding:8px; text-align:center; vertical-align:middle;">${escapeHtml(
                    formData[key] || ""
                  )}</td>
                </tr>
              `
                  )
                  .join("")
              : ""
          }
        </tbody>
      </table>

      <h2>Attachments</h2>
      <table style="width:100%; border-collapse:collapse; margin-top:16px;">
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:8px; text-align:center; width:10px">S.No</th>
            <th style="border:1px solid #000; padding:8px; text-align:left;">Description</th>
            <th style="border:1px solid #000; padding:8px; text-align:left;">File Name</th>
          </tr>
        </thead>
        <tbody>
          ${[1, 2, 3, 4]
            .map((i) => {
              const att = formData[`attachments${i}`] || {};
              const desc = escapeHtml(att.description || "");
              const fname = escapeHtml((att.file && att.file.name) || "");
              return `
                <tr>
                  <td style="border:1px solid #000; padding:8px; text-align:center; vertical-align:middle;">${i}</td>
                  <td style="border:1px solid #000; padding:8px; text-align:start;">${desc}</td>
                  <td style="border:1px solid #000; padding:8px; text-align:start;">${fname}</td>
                </tr>
              `;
            })
            .join("")}
        </tbody>
      </table>

      <h2>Comments</h2>
      <p>${escapeHtml(formData.comment || "")}</p>

      <h2>Declaration</h2>
      <p>I declare that the information submitted is true and complete.</p>
      <br/>
      <p><strong>Approving Authority Name:</strong> ${escapeHtml(
        formData.authorityName || ""
      )}</p>
      <p><strong>Approving Authority Designation:</strong> ${escapeHtml(
        formData.authorityTitle || ""
      )}</p>
      <p><strong>Signed on:</strong> ${escapeHtml(
        formData.signatureDate || new Date().toLocaleDateString()
      )}</p>
      <p><strong>Approving Authority Signature:</strong></p>
    </div>
  `;

    const fullHtml = `<!doctype html>
    <html>
      <head>
        <meta charset="utf-8">
        <title>${title}</title>
        <style>
          @page { margin: 20mm; }
          body { font-family: Arial, sans-serif; margin:0; padding:0; }
        </style>
      </head>
      <body>${bodyHtml}</body>
    </html>`;

    const printWindow = window.open("", "_blank", "height=800,width=1000");
    printWindow.document.open();
    printWindow.document.write(fullHtml);
    printWindow.document.close();

    // ensure title is set so print header won't show "about:blank"
    try {
      printWindow.document.title = title;
    } catch (e) {
      /* ignore */
    }

    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      // optionally close print window after printing:
      // printWindow.close();
    }, 300);
  };

  // Navigation handlers
  const nextStep = () => {
    let newErrors = {};
    if (currentStep === 1) {
      if (!formData.mailingAddress.trim()) {
        alert("Mailing address is required.");
        return;
      }
    }
    if (currentStep === 2) {
      if (!formData.authorityName) {
        alert("Authority name is required.");
        return;
      }
      if (!formData.authorityTitle) {
        alert("Authority designation is required.");
        return;
      }
      if (!formData.authorityEmail || !validateEmail(formData.authorityEmail)) {
        alert("Please enter a valid Authority email.");
        return;
      }
      // if (!formData.authorityPhone || !validatePhone(formData.authorityPhone)) {
      //     alert('Authority phone must be exactly 10 digits.');
      //     return;
      // }
      if (!formData.authorityLandline) {
        alert("Authority Landline is required.");
        return;
      }
      if (!formData.contact_name) {
        alert("Contact name is required.");
        return;
      }
      if (formData.contact_email && !validateEmail(formData.contact_email)) {
        alert("Please enter a valid Contact email.");
        return;
      }
      if (
        formData.contact_phone &&
        !validatePhone(formData.contact_phone) &&
        !copyApplicantData
      ) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (
        formData.contactapplicant &&
        !validatePhone(formData.contactapplicant)
      ) {
        alert("Contact phone must be exactly 10 digits.");
        return;
      }
      if (!formData.ApplicantDOB) {
        alert("Applicant DOB is required.");
        return;
      }
      if (!formData.Applicantdesignation) {
        alert("Applicant designation is required.");
        return;
      }
      if (!formData.Applicantjoining) {
        alert("Applicant joining date is required.");
        return;
      }
      if (!formData.Applicantprofile) {
        alert("Applicant profile is required.");
        return;
      }
      if (!formData.Applicantdetails) {
        alert("Applicant educational qualifications are required.");
        return;
      }
      if (!formData.companyProfile) {
        alert("Company Profile is required.");
        return;
      }
    }
    if (currentStep === 3 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return; // Stay on step
      }
    }
    if (currentStep === 4 && hasEmptyFieldsInStep(currentStep)) {
      if (!window.confirm("Data not entered, If you wish to continue?")) {
        return; // Stay on step
      }
    }

    setError("");
    if (currentStep < 5) setCurrentStep((prev) => prev + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  // Save draft handler
  const handleSaveDraft = () => {
    localStorage.setItem("registration-weDraft", JSON.stringify({ formData }));
    handleSubmit(null);
    alert("Draft Saved!");
  };

  //Final Submit button

  useEffect(() => {
    if (userInfo) {
      validateFormCount().catch((err) => {
        alert(`${err.message}`);
        setDisableSave(true);
      });
    }
  }, [userInfo]);

  const validateFormCount = async () => {
    const url = `/registration-we/?organisation_name=${userInfo.organisation_name}&form_mode=submit`;
    const res = await apiClient.get(url);

    if (res?.data?.length === 2) {
      // disable buttons
      setDisableSave(true);
      throw new Error(
        "You have reached the maximum limit of 2 forms for this organisation."
      );
    }
  };

  // Submit form handler
  async function handleSubmit(event, clickType = "draft") {
    if (event) {
      event?.preventDefault();
    }
    try {
      await validateFormCount();

      // 1) Make a local copy of formData so we don't rely on async state updates
      let payload = { ...formData };

      // 2) Merge user_info synchronously (don't call setFormData here)
      try {
        const raw = localStorage.getItem("user_info");
        if (raw) {
          const u = JSON.parse(raw);
          payload.userid = u.id || "";
          payload.firstname = u.first_name || "";
          payload.lastname = u.last_name || "";
          payload.company_name = u.organisation_name ?? payload.company_name;
          payload.Organisationname =
            u.organisation_name ?? payload.Organisationname;
        }
      } catch (err) {
        console.warn("Failed to load user_info:", err);
      }

      const fd = new FormData();

      // ─── Identity / Org Info ─────────────────────────────
      fd.append("organisation_name", formData.Organisationname);
      fd.append("firstname", formData.firstname);
      fd.append("lastname", formData.lastname);
      fd.append("category", formData.category);
      fd.append("company_name", formData.Organisationname);
      fd.append("mailing_address", formData.mailingAddress);

      // ─── Authority ───────────────────────────────────────
      fd.append("authority_name", formData.authorityName);
      fd.append("authority_title", formData.authorityTitle);
      fd.append("authority_phone", formData.authorityPhone);
      fd.append("authorityLandline", formData.authorityLandline);
      fd.append("authority_email", formData.authorityEmail);
      fd.append("form_id", formId);
      fd.append("form_mode", clickType);
      // Add Table Pk Id;
      if (PkId > 0) fd.append("id", PkId);

      if (payload.approvingAuthoritySignature instanceof File) {
        fd.append(
          "approving_authority_file",
          payload.approvingAuthoritySignature
        );
      }

      // ─── Contact ─────────────────────────────────────────
      fd.append("contact_name", formData.contact_name);
      fd.append("contact_phone", formData.contact_phone);
      fd.append("contact_email", formData.contact_email);

      // ─── Applicant ───────────────────────────────────────
      fd.append("contact_applicant", formData.contactapplicant || "");
      fd.append("we_applicant_name", formData.we_applicant_name || "");
      fd.append("applicant_dob", formData.ApplicantDOB);
      fd.append("applicant_designation", formData.Applicantdesignation);
      fd.append("applicant_profile", formData.Applicantprofile);
      fd.append("applicant_details", formData.Applicantdetails);
      fd.append("applicant_joining", formData.Applicantjoining);

      // ─── Other Info ──────────────────────────────────────
      fd.append("company_profile", formData.companyProfile);
      fd.append("award_justification", formData.awardJustification);
      fd.append("comment", formData.comment);
      fd.append("declaration", formData.declaration);

      // ─── WE Questions ────────────────────────────────────
      fd.append("we_1", formData.WE_1);
      fd.append("we_2", formData.WE_2);
      fd.append("we_3", formData.WE_3);
      fd.append("we_4", formData.WE_4);
      fd.append("we_5", formData.WE_5);
      fd.append("we_6", formData.WE_6);

      // ─── Attachments ─────────────────────────────────────
      for (let i = 1; i <= 4; i++) {
        const fileObj = formData[`attachments${i}`];
        if (fileObj) {
          fd.append(`attachments${i}_desc`, fileObj.description || "");
          if (fileObj.file) {
            fd.append(`attachments${i}`, fileObj.file);
          }
        }
      }

      try {
        const response = await apiClient.post("/registration-we/", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        // When User save the Data It will Prefill the form data and fill pkId
        prefillFormData();
      } catch (err) {
        console.error("registration-we submission error:", err);
        const serverMsg =
          err?.response?.data ?? err?.message ?? JSON.stringify(err);
        alert("Submission failed: " + JSON.stringify(serverMsg));
      }
    } catch (err) {
      console.error(`Error submitting form :: ${err}`);
    }
  }

  // Quantitative data for steps 3 and 4
  const fullData = [
    ["1", "Initiatives/exceptional contribution in the line of work", "WE_1"],
    ["2", "Key examples of mentorship given to junior/new team member", "WE_2"],
    [
      "3",
      "Key examples which demonstrate exceptional technical or professional expertise ",
      "WE_3",
    ],
    [
      "4",
      "Key examples which demonstrate inputs in strategic perspective towards management decisions",
      "WE_4",
    ],
    [
      "5",
      "Outline barriers or difficulties faced and how they have been overcome ",
      "WE_5",
    ],
    [
      "6",
      "Work done/achievements (if any) in the area of environmental improvement/decarbonization/net zero targets",
      "WE_6",
    ],
  ];

  const part1 = fullData.filter(([num]) => parseFloat(num) <= 4);
  const part2 = fullData.filter(([num]) => parseFloat(num) > 4);

  const hasEmptyFieldsInStep = (step) => {
    const fields = step === 3 ? part1 : part2;
    for (const [, , key] of fields) {
      const val = formData[key];
      if (!val || val.trim() === "") return true;
    }

    // For step 4, also check the comment field

    return false;
  };
   const viewFile =  async (serverPath) => {
    // "https://award-backend.fipi.org.in/media/
    const extractPath = serverPath.split('/').filter(
  (val) =>
    val !== "" && // remove empty strings
    val !== "http:" &&
    val !== "https:" &&
    val !== "media" &&
    !val.startsWith("award") &&
    !val.startsWith("localhost")
).join('/');
    
    downloadFile(extractPath)
  }

  // Rendering steps content
  const renderStepContent = () => {
    const progress = ((currentStep - 1) / 4) * 100;

    return (
      <div
        className="form-step"
        role="form"
        aria-label={`Step ${currentStep} of 5`}
      >
        <div className="progress-bar" aria-hidden="true">
          <div className="progress" style={{ width: `${progress}%` }} />
        </div>

        {currentStep === 1 && (
          <>
            <h3 className="step-title">Step 1: Organization Details</h3>
            <div className="form-group">
              <label htmlFor="Organisationname">
                Organisation Name:{" "}
                <span aria-hidden="true" className="text-red">
                  *
                </span>
              </label>
              <input
                id="Organisationname"
                name="Organisationname"
                type="text"
                maxLength={FIELD_MAX_LENGTH}
                value={formData.Organisationname}
                // onChange={(e) => handleChange('Organisationname', e.target.value)}
                disabled={true}
                aria-describedby="Organisationname-error"
                className={`form-input ${
                  !formData.Organisationname && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
                placeholder="Enter organisation name"
                required
              />
              {fieldErrors.Organisationname && (
                <span
                  className="error-tooltip"
                  id="Organisationname-error"
                  role="alert"
                >
                  {fieldErrors.Organisationname}
                </span>
              )}
              {!formData.Organisationname && currentStep === 1 && (
                <span
                  className="error-tooltip"
                  id="Organisationname-error"
                  role="alert"
                >
                  Organisation name is required
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="mailingAddress">
                Postal Address:{" "}
                <span aria-hidden="true" className="text-red">
                  *
                </span>
              </label>
              <textarea
                id="mailingAddress"
                name="mailingAddress"
                value={formData.mailingAddress}
                rows={3}
                maxLength={FIELD_MAX_LENGTH}
                onChange={(e) => handleChange("mailingAddress", e.target.value)}
                aria-describedby="mailingAddress-error"
                placeholder="Enter postal address"
                className={`form-textarea ${
                  !formData.mailingAddress.trim() && currentStep === 1
                    ? "has-error"
                    : ""
                }`}
                required
              />
              {fieldErrors.mailingAddress && (
                <span
                  className="error-tooltip"
                  id="mailingAddress-error"
                  role="alert"
                >
                  {fieldErrors.mailingAddress}
                </span>
              )}
              {!formData.mailingAddress.trim() && currentStep === 1 && (
                <span
                  className="error-tooltip"
                  id="mailingAddress-error"
                  role="alert"
                >
                  Mailing address is required
                </span>
              )}
            </div>
          </>
        )}

        {currentStep === 2 && (
          <>
            <h3 className="step-title">
              Step 2: Approving Authority, Contact & Applicant Details
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <section
                aria-labelledby="approving-authority-heading"
                className="step-section"
              >
                <h4 id="approving-authority-heading">Approving Authority</h4>
                <p className="note">
                  Approving authority should be CMD/MD in case of PSUs and CEO
                  or equivalent senior executive in case of private Companies
                </p>
                <div className="form-group">
                  <label htmlFor="authorityName">
                    Name:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityName"
                    name="authorityName"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityName}
                    onChange={(e) =>
                      handleChange("authorityName", e.target.value)
                    }
                    aria-describedby="authorityName-error"
                    placeholder="Name"
                    className={`form-input ${
                      !formData.authorityName && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.authorityName && (
                    <span
                      className="error-tooltip"
                      id="authorityName-error"
                      role="alert"
                    >
                      {fieldErrors.authorityName}
                    </span>
                  )}
                  {!formData.authorityName && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="authorityName-error"
                      role="alert"
                    >
                      Name is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityTitle">
                    Designation:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityTitle"
                    name="authorityTitle"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityTitle}
                    onChange={(e) =>
                      handleChange("authorityTitle", e.target.value)
                    }
                    aria-describedby="authorityTitle-error"
                    placeholder="Designation"
                    className={`form-input ${
                      !formData.authorityTitle && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.authorityTitle && (
                    <span
                      className="error-tooltip"
                      id="authorityTitle-error"
                      role="alert"
                    >
                      {fieldErrors.authorityTitle}
                    </span>
                  )}
                  {!formData.authorityTitle && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="authorityTitle-error"
                      role="alert"
                    >
                      Designation is required
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="authorityPhone">
                    Landline:{" "}
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityLandline"
                    type="number"
                    name="authorityLandline"
                    value={formData.authorityLandline}
                    onChange={(e) =>
                      handleChange("authorityLandline", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityLandline', e.target.value)}
                    className={`form-input ${
                      !formData.authorityLandline && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    placeholder="Landline number"
                    aria-required="true"
                    aria-describedby={
                      fieldErrors.authorityLandline
                        ? "authorityLandline-error"
                        : undefined
                    }
                  />
                  {!formData.authorityLandline && currentStep === 2 && (
                    <span className="error-tooltip">
                      Authority Landline Number is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="authorityPhone">Mobile: </label>
                  <input
                    id="authorityPhone"
                    type="tel"
                    name="authorityPhone"
                    value={formData.authorityPhone}
                    onChange={(e) =>
                      handleChange("authorityPhone", e.target.value)
                    }
                    // onBlur={(e) => handleBlur('authorityPhone', e.target.value)}
                    className={`form-input`}
                    placeholder="Phone number"
                    maxLength={PHONE_MAX_LENGTH}
                    aria-required="true"
                    // aria-describedby={fieldErrors.authorityPhone ? 'authorityPhone-error' : undefined}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="authorityEmail">
                    Email:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="authorityEmail"
                    name="authorityEmail"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.authorityEmail}
                    onChange={(e) =>
                      handleChange("authorityEmail", e.target.value)
                    }
                    aria-describedby="authorityEmail-error"
                    placeholder="Approving authority's email"
                    className={`form-input ${
                      !formData.authorityEmail && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.authorityEmail && (
                    <span
                      className="error-tooltip"
                      id="authorityEmail-error"
                      role="alert"
                    >
                      {fieldErrors.authorityEmail}
                    </span>
                  )}
                  {!formData.authorityEmail && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="authorityEmail-error"
                      role="alert"
                    >
                      Email is required
                    </span>
                  )}
                </div>
              </section>
              <section
                aria-labelledby="contacts-heading"
                className="step-section"
              >
                <h4 id="contacts-heading">
                  Contacts (Nodal Officials){" "}
                  <span aria-hidden="true" className="text-red">
                    *
                  </span>
                </h4>
                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="copyApplicantData"
                      //   checked={copyApplicantData}
                      onChange={handleCopyApplicantToggle}
                      className="form-checkbox"
                    />{" "}
                    Same as applicant
                  </label>
                </div>

                <div className="form-group">
                  <label htmlFor="contact_name">
                    Name:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_name"
                    name="contact_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_name}
                    onChange={(e) =>
                      handleChange("contact_name", e.target.value)
                    }
                    placeholder="Contact name"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.contact_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="contact_name-error"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_phone">
                    Phone:
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_phone"
                    name="contact_phone"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contact_phone}
                    onChange={(e) =>
                      handleChange("contact_phone", e.target.value)
                    }
                    aria-describedby="contact_phone-error"
                    disabled={copyApplicantData}
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contact_phone && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="contact_email">
                    Email:
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <input
                    id="contact_email"
                    name="contact_email"
                    type="email"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.contact_email}
                    onChange={(e) =>
                      handleChange("contact_email", e.target.value)
                    }
                    placeholder="Contact email"
                    disabled={copyApplicantData}
                    className={`form-input ${
                      fieldErrors.contact_email ? "has-error" : ""
                    }`}
                    aria-describedby="contact_email-error"
                  />
                </div>
              </section>
              <section
                aria-labelledby="applicant-details-heading"
                className="step-section"
              >
                
                <h4 id="applicant-details-heading">
                  Applicant Details{" "}
                  <span aria-hidden="true" className="text-red">
                    *
                  </span>
                </h4>
                <div className="form-group">
                  <label htmlFor="contact_name">
                   Applicant Name:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="we_applicant_name"
                    name="we_applicant_name"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.we_applicant_name}
                    onChange={(e) =>
                      handleChange("we_applicant_name", e.target.value)
                    }
                    placeholder="Applicant Name"
                    // disabled={copyApplicantData}
                    className={`form-input ${
                      !formData.we_applicant_name && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    aria-describedby="we_applicant_name-error"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="contactapplicant">
                    Phone:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="contactapplicant"
                    name="contactapplicant"
                    type="tel"
                    maxLength={PHONE_MAX_LENGTH}
                    value={formData.contactapplicant}
                    onChange={(e) =>
                      handleChange("contactapplicant", e.target.value)
                    }
                    aria-describedby="contactapplicant-error"
                    placeholder="10-digit phone number"
                    className={`form-input ${
                      !formData.contactapplicant && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.contactapplicant && (
                    <span
                      className="error-tooltip"
                      id="contactapplicant-error"
                      role="alert"
                    >
                      {fieldErrors.contactapplicant}
                    </span>
                  )}
                  {!formData.contactapplicant && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="contactapplicant-error"
                      role="alert"
                    >
                      Phone is required
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="ApplicantDOB">
                    Date of Birth:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="ApplicantDOB"
                    name="ApplicantDOB"
                    type="date"
                    value={formData.ApplicantDOB}
                    onChange={(e) =>
                      handleChange("ApplicantDOB", e.target.value)
                    }
                    aria-describedby="ApplicantDOB-error"
                    className={`form-input ${
                      !formData.ApplicantDOB && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.ApplicantDOB && (
                    <span
                      className="error-tooltip"
                      id="ApplicantDOB-error"
                      role="alert"
                    >
                      {fieldErrors.ApplicantDOB}
                    </span>
                  )}
                  {!formData.ApplicantDOB && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="ApplicantDOB-error"
                      role="alert"
                    >
                      DOB is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Applicantdesignation">
                    Current Designation:
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="Applicantdesignation"
                    name="Applicantdesignation"
                    type="text"
                    maxLength={FIELD_MAX_LENGTH}
                    value={formData.Applicantdesignation}
                    onChange={(e) =>
                      handleChange("Applicantdesignation", e.target.value)
                    }
                    aria-describedby="Applicantdesignation-error"
                    placeholder="Applicant Designation"
                    className={`form-input ${
                      !formData.Applicantdesignation && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.Applicantdesignation && (
                    <span
                      className="error-tooltip"
                      id="Applicantdesignation-error"
                      role="alert"
                    >
                      {fieldErrors.Applicantdesignation}
                    </span>
                  )}
                  {!formData.Applicantdesignation && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="Applicantdesignation-error"
                      role="alert"
                    >
                      Designation is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Applicantprofile">
                    Career Profile
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <p className="note"> (within 100 words)</p>
                  <textarea
                    id="Applicantprofile"
                    name="Applicantprofile"
                    value={formData.Applicantprofile}
                    // maxLength={TEXTAREA_MAX_LENGTH}
                    onChange={(e) =>
                      handleChange("Applicantprofile", e.target.value)
                    }
                    className={`form-textarea ${
                      !formData.Applicantprofile && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    rows={6}
                    aria-describedby="Applicantprofile-error"
                    required
                  />
                  {fieldErrors.Applicantprofile && (
                    <span
                      className="error-tooltip"
                      id="Applicantprofile-error"
                      role="alert"
                    >
                      {fieldErrors.Applicantprofile}
                    </span>
                  )}
                  {!formData.Applicantprofile && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="Applicantprofile-error"
                      role="alert"
                    >
                      Profile is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Applicantdetails">
                    Educational qualifications with name of institutions, years
                    passed out & total percentage of marks received/grade/points
                    (Graduation & upwards)
                    <span className="text-red" aria-hidden="true">
                      *
                    </span>
                  </label>
                  <textarea
                    id="Applicantdetails"
                    name="Applicantdetails"
                    value={formData.Applicantdetails}
                    // maxLength={TEXTAREA_MAX_LENGTH}
                    onChange={(e) =>
                      handleChange("Applicantdetails", e.target.value)
                    }
                    className={`form-textarea ${
                      !formData.Applicantdetails && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    rows={6}
                    aria-describedby="Applicantdetails-error"
                    required
                  />
                  {fieldErrors.Applicantdetails && (
                    <span
                      className="error-tooltip"
                      id="Applicantdetails-error"
                      role="alert"
                    >
                      {fieldErrors.Applicantdetails}
                    </span>
                  )}
                  {!formData.Applicantdetails && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="Applicantdetails-error"
                      role="alert"
                    >
                      Applicant Details is required
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="Applicantjoining">
                    Date of joining the organization:{" "}
                    <span aria-hidden="true" className="text-red">
                      *
                    </span>
                  </label>
                  <input
                    id="Applicantjoining"
                    name="Applicantjoining"
                    type="date"
                    value={formData.Applicantjoining}
                    onChange={(e) =>
                      handleChange("Applicantjoining", e.target.value)
                    }
                    aria-describedby="Applicantjoining-error"
                    className={`form-input ${
                      !formData.Applicantjoining && currentStep === 2
                        ? "has-error"
                        : ""
                    }`}
                    required
                  />
                  {fieldErrors.Applicantjoining && (
                    <span
                      className="error-tooltip"
                      id="Applicantjoining-error"
                      role="alert"
                    >
                      {fieldErrors.Applicantjoining}
                    </span>
                  )}
                  {!formData.Applicantjoining && currentStep === 2 && (
                    <span
                      className="error-tooltip"
                      id="Applicantjoining-error"
                      role="alert"
                    >
                      Date of Joining is required
                    </span>
                  )}
                </div>
              </section>
            </div>
            <div className="form-group">
              <label htmlFor="companyProfile">
                Mention the rationale behind applying for this award (emphasis
                be on quantitative achievements such as cost saving, sale
                enhancement, efficiency in energy consumption, safety,
                environment etc.)
                <span className="text-red" aria-hidden="true">
                  *
                </span>
              </label>
              <p className="note">
                Write up by applicant (Not more than 300 words)
              </p>
              <textarea
                id="companyProfile"
                name="companyProfile"
                value={formData.companyProfile}
                // maxLength={TEXTAREA_MAX_LENGTH}
                onChange={(e) => handleChange("companyProfile", e.target.value)}
                className="form-textarea"
                rows={6}
                aria-describedby="companyProfile-error"
              />
              {fieldErrors.companyProfile && (
                <span
                  className="error-tooltip"
                  id="companyProfile-error"
                  role="alert"
                >
                  {fieldErrors.companyProfile}
                </span>
              )}
            </div>
          </>
        )}

        {/* Step 3: Quantitative Information Part 1 */}
        {currentStep === 3 && (
          <>
            <h3 className="step-title">
              Step 3: Quantitative Information Part 1
            </h3>
            {part1.map(([num, label, key]) => (
              <div key={key} className="form-group">
                <label htmlFor={key}>
                  {num}. {label}
                </label>
                <p className="note">Write up (Within 200 words)</p>
                <textarea
                  id={key}
                  name={key}
                  value={formData[key] || ""}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className="form-textarea"
                  rows={6}
                  // maxLength={WE_FIELD_MAX_LENGTH}
                  aria-describedby={`${key}-error`}
                />
                {fieldErrors[key] && (
                  <span
                    className="error-tooltip"
                    id={`${key}-error`}
                    role="alert"
                  >
                    {fieldErrors[key]}
                  </span>
                )}
              </div>
            ))}
          </>
        )}

        {/* Step 4: Quantitative Information Part 2 */}
        {currentStep === 4 && (
          <>
            <h3 className="step-title">
              Step 4: Quantitative Information Part 2
            </h3>
            {part2.map(([num, label, key]) => (
              <div key={key} className="form-group">
                <label htmlFor={key}>
                  {num}. {label}
                  {label.includes("(Within 200 words)") && (
                    <span> (Within 200 words)</span>
                  )}
                </label>
                <p className="note">Write up (Within 200 words)</p>
                <textarea
                  id={key}
                  name={key}
                  value={formData[key] || ""}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className="form-textarea"
                  rows={6}
                  // maxLength={WE_FIELD_MAX_LENGTH}
                  aria-describedby={`${key}-error`}
                />
                {fieldErrors[key] && (
                  <span
                    className="error-tooltip"
                    id={`${key}-error`}
                    role="alert"
                  >
                    {fieldErrors[key]}
                  </span>
                )}
              </div>
            ))}

            <div className="form-group">
              <label htmlFor="comment">Comments</label>
              <textarea
                id="comment"
                name="comment"
                value={formData.comment}
                // maxLength={WE_FIELD_MAX_LENGTH}
                onChange={(e) => handleChange("comment", e.target.value)}
                className="form-textarea"
                placeholder="Comments in (200 words) against input parameter, if any"
                aria-describedby="comment-error"
              />
              {fieldErrors.comment && (
                <span className="error-tooltip" id="comment-error" role="alert">
                  {fieldErrors.comment}
                </span>
              )}
            </div>
          </>
        )}

        {currentStep === 5 && (
          <>
            <h3 className="step-title">Step 5: Attachments & Declaration</h3>
            <div className="form-group">
              <label>List of Attachments (Optional):</label>
              <table className="quant-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Description</th>
                    <th>Upload (only jpg, png, pdf, max 5 MB each)</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            maxLength={FIELD_MAX_LENGTH}
                            value={formData[key].description}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            className="form-input"
                            aria-describedby={`${key}-description-error`}
                          />
                          {fieldErrors[`${key}.description`] && (
                            <span
                              className="error-tooltip"
                              id={`${key}-description-error`}
                              role="alert"
                            >
                              {fieldErrors[`${key}.description`]}
                            </span>
                          )}
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                            aria-describedby={`${key}-file-error`}
                          />
                          {formData[key].file && (
                            <p className="file-name">
                              Selected file: {formData[key].file.name}
                            </p>
                          )}
                          {fieldErrors[`${key}.file`] && (
                            <span
                              className="error-tooltip"
                              id={`${key}-file-error`}
                              role="alert"
                            >
                              {fieldErrors[`${key}.file`]}
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody> */}
                <tbody>
                  {[1, 2, 3, 4].map((num) => {
                    const key = `attachments${num}`;
                    const attachment = formData[key] || {
                      description: "",
                      file: null,
                    };
                    return (
                      <tr key={key}>
                        <td>{num}</td>
                        <td>
                          <input
                            type="text"
                            name={`${key}.description`}
                            value={attachment.description}
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "description",
                                e.target.value
                              )
                            }
                            placeholder="Enter description"
                            maxLength={FIELD_MAX_LENGTH}
                            className="form-input"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            accept=".jpg,.png,.pdf"
                            onChange={(e) =>
                              handleAttachmentChange(
                                key,
                                "file",
                                e.target.files[0],
                                e
                              )
                            }
                            className="form-input mt-4"
                          />
                          {attachment.file && (
                            <p className="file-name">
                              Selected file: {attachment.file.name}
                            </p>
                          )}
                          {attachment.url && !attachment.file && (
                            <p className="file-name">
                              Uploaded file:{" "}
                              <button
                                type="button"
                                onClick={() => viewFile(attachment.url)}
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  color: "#06c",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                View
                              </button>
                            </p>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="form-group">
              <label>
                Print the completed application form and upload it with the
                signature of the approving authority. Without signature of the
                approving authority, application will not be considered valid.
                <span aria-hidden="true" className="text-red">
                  *
                </span>
              </label>
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={handlePrint}
                  className="btn btn-outline"
                >
                  Print Preview
                </button>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="approvingAuthoritySignature">
                Upload Document with Approving Authority Signature
                (Director/Board Level)
                <span aria-hidden="true" className="text-red">
                  *
                </span>
                :
              </label>
              <input
                type="file"
                id="approvingAuthoritySignature"
                accept=".jpg,.png,.pdf"
                onChange={(e) => {
                  const files = e.target.files;
                  if (files.length > 0) {
                    const confirmed = window.confirm(
                      "Are you sure the form is approved and signed by approving authority?"
                    );
                    if (!confirmed) {
                      // If user clicks "Cancel", clear the input
                      e.target.value = "";
                      return;
                    }
                    handleApprovingAuthorityChange(files);
                  }
                }}
                className={`form-input mt-4 ${
                  fieldErrors.approvingAuthoritySignature ? "has-error" : ""
                }`}
                aria-describedby="approvingAuthoritySignature-error"
                required
              />
              {formData.approvingAuthoritySignature && (
                <p className="file-name">
                  Selected file: {formData.approvingAuthoritySignature.name}
                </p>
              )}
              {formData.approvingAuthoritySignatureUrl &&
                !formData.approvingAuthoritySignature && (
                  <p className="file-name">
                    Uploaded file:{" "}
                    <button
                      type="button"
                      onClick={() =>
                        viewFile(formData.approvingAuthoritySignatureUrl)
                      }
                      style={{
                        background: "none",
                        border: "none",
                        padding: 0,
                        color: "#06c",
                        cursor: "pointer",
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  </p>
                )}
              {fieldErrors.approvingAuthoritySignature && (
                <span
                  className="error-tooltip"
                  id="approvingAuthoritySignature-error"
                  role="alert"
                >
                  {fieldErrors.approvingAuthoritySignature}
                </span>
              )}
            </div>

            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="declaration"
                  checked={formData.declaration}
                  onChange={(e) =>
                    handleChange("declaration", e.target.checked)
                  }
                  className="form-checkbox"
                />
                I declare that the information submitted is true and complete.
              </label>
            </div>
          </>
        )}
      </div>
    );
  };
  useEffect(() => {
    const middlePosition = window.innerHeight / 2; // middle
    window.scrollTo({ top: middlePosition + 100, behavior: "smooth" });
  }, [currentStep]);

  return (
    <div className="sidebar-guideline-container">
      <SidebarGuideline
        isOpen={true}
        sidebarItems={[{ id: "Guideline", label: "Guideline" }]}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        selectedAwardCategory={formData.category}
      />
      <div className="application-form">
        <div className="form-header">
          <h1>{awardTitle}</h1>
          <h6>Step {currentStep} of 5</h6>
        </div>
        {error && <div className="error">{error}</div>}
        {isSubmitted ? (
          <div className="thank-you-message">
            <h2>Thank you for your submission!</h2>
            <p>Your Application has been successfully submitted.</p>
            <button onClick={() => navigate("/#Award%20Categories")}>
              Submit Another Application
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {renderStepContent()}
            {currentStep === 1 && (
              <div className="form-navigation-step1">
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                <button
                  type="button"
                  onClick={nextStep}
                  className="btn btn-primary"
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            )}
            {currentStep > 1 && (
              <div className="form-navigation">
                <button
                  type="button"
                  onClick={prevStep}
                  className="btn btn-outline"
                >
                  <ChevronLeft size={16} /> Previous
                </button>
                <button
                  type="button"
                  onClick={handleSaveDraft}
                  className="btn btn-outline"
                  disabled={isSubmited()}
                >
                  <Save size={16} /> Save Draft
                </button>
                {currentStep < 5 && (
                  <button
                    type="button"
                    onClick={nextStep}
                    className="btn btn-primary"
                  >
                    Next <ChevronRight size={16} />
                  </button>
                )}
                {currentStep === 5 && (
                  <button
                    type="button"
                    className="btn btn-success"
                    disabled={isSubmited()}
                    onClick={(e) => {
                      if (!formData.declaration) {
                        return alert(
                          "Please accept the declaration before submitting."
                        );
                      }
                      if (!formData.approvingAuthoritySignature) {
                        return alert(
                          "Please upload the approving authority signature file."
                        );
                      }
                      if (!window.confirm("Are you sure you want to submit?")) {
                        e.preventDefault();
                      }
                      alert("Women registration submitted successfully!");
                      setIsSubmitted(true);

                      handleSubmit(e, "submit");
                    }}
                  >
                    Submit
                  </button>
                )}
              </div>
            )}
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationWE;
